import { FC } from "react";
import { VStack } from "@design-system/VStack/VStack";
import {
    StandardModalFooter,
    StandardModalHeader,
} from "@design-system/Modal/Modal";
import { Button } from "@design-system/Button/Button";
import actionsStyles from "../ClientActions.module.scss";
import styles from "./OrgWorkspaceWarningModal.module.scss";

interface Props {
    onClose: () => void;
}

export const PlanManagedByClientModal: FC<Props> = ({ onClose }) => (
    <>
        <StandardModalHeader className={actionsStyles.modalHeader}>
            Multi-entity not supported on this plan
        </StandardModalHeader>
        <VStack gap={8} className="mt-2">
            <div>
                Adding an entity requires a Plus plan. This client manages their
                own billing, so they will need to upgrade their plan directly.
            </div>
        </VStack>
        <StandardModalFooter className={styles.footer}>
            <Button type="button" variant="primary" onClick={onClose} size="xl">
                Close
            </Button>
        </StandardModalFooter>
    </>
);
